module.exports = __webpack_public_path__ + "media/images/1845-d6f737c6dff9b9b8898eaaa010ed717c.jpg";